import { useEffect, useState } from "react"
import { Box, Grid, Typography, useTheme } from "@mui/material"
import { TableBase } from "../../components"
import GrupoService from "../../services/grupo.service";

const GruposViewScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [itemsG, setItemsG] = useState([]);
    const datosGrupos = async () => {
        await GrupoService.getAll().then((r)=>{
            setItemsG(r)
        })
    };
    useEffect(() => {
        datosGrupos();
        document.title = 'Grupos'
    }, [])

    const columnsGrupo = [
        {
            name: "id_g",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_g",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "personal",
            label: "Integrantes",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto',backgroundColor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} spacing={2}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Grupos</Typography>
                        </Grid>
                        <Grid item xs={12} mt={2} sx={{marginBottom: 15}}>
                            <TableBase title='Resultados' columns={columnsGrupo} data={itemsG} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default GruposViewScreen